import { render, staticRenderFns } from "./sureCheck.vue?vue&type=template&id=45ad701c&"
import script from "./sureCheck.vue?vue&type=script&lang=js&"
export * from "./sureCheck.vue?vue&type=script&lang=js&"
import style0 from "./sureCheck.vue?vue&type=style&index=0&id=45ad701c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports